<template>
  <div class="d-flex justify-content-center my-5">  
    <b-modal :id="modalName" :size="modalSize" title="Acceso / Login"
        hide-header ok-only hide-backdrop content-class="shadow" 
        button-size="sm" centered ok-title="Cancelar" ok-variant="outline-secondary">        
        <b-card title=""
            bg-variant="light"
            border-variant="success"
            style="max-width: 500px;"
            >            
            <component :is="modalComponent"></component>
        </b-card>
    </b-modal>
  </div>
</template>

<script>

export default {
  name: 'modalX',
  props: {
    modal: String,
    size: String,
  },  
  data() {
    return {
      
    };
  },
  computed: {
      //modalComponent: 'modalComponent',
      modalName() {
          return "modal_"+this.modal;
      },
      modalSize() {
          return this.size;
      },
      modalComponent() {
          return this.modal;
      },
  },
  methods: {
      close() {
        this.hideModal();    
        //this.$bvModal.hide(this.modal);
      },    
  }
   
}

</script>
